export const CHECKOUT_RESUME_LOGIN_REQUIRED = "CHECKOUT_RESUME_LOGIN_REQUIRED";
export const CHECKOUT_RESUME_OWNER_MISMATCH = "CHECKOUT_RESUME_OWNER_MISMATCH";
export const CHECKOUT_ORDER_LOGIN_REQUIRED = "CHECKOUT_ORDER_LOGIN_REQUIRED";
export const CHECKOUT_ORDER_OWNER_MISMATCH = "CHECKOUT_ORDER_OWNER_MISMATCH";

const CHECKOUT_RESUME_PATHS = ["/checkout-reanudar/", "/checkout-reanudar-guid/"];

export const getCheckoutResumeErrorCode = (error: unknown): string | null => {
    const cause = (error as any)?.cause;
    return cause?.response?.data?.codigo ?? null;
};

export const getSafeCheckoutResumeReturnUrl = (returnUrl: string | null | undefined): string => {
    if (!returnUrl || !returnUrl.startsWith("/") || returnUrl.startsWith("//")) {
        return "/";
    }

    try {
        const url = new URL(returnUrl, "https://storefront.local");
        const esRutaReanudacion = CHECKOUT_RESUME_PATHS.some((path) =>
            url.pathname.startsWith(path),
        );

        return url.origin === "https://storefront.local" && esRutaReanudacion
            ? `${url.pathname}${url.search}${url.hash}`
            : "/";
    } catch {
        return "/";
    }
};

export const buildCheckoutResumeLoginUrl = (returnUrl: string): string => {
    const safeReturnUrl = getSafeCheckoutResumeReturnUrl(returnUrl);
    const params = new URLSearchParams({
        motivo: "checkout-resume",
        returnUrl: safeReturnUrl,
    });

    return `/login?${params.toString()}`;
};

interface StorefrontLocation {
    pathname: string;
    search: string;
    hash: string;
}

export const getStorefrontLogoutRedirectUrl = (location?: StorefrontLocation): string => {
    const currentLocation = location ?? (typeof window !== "undefined" ? window.location : null);

    if (!currentLocation) return "/login";

    const currentUrl = `${currentLocation.pathname}${currentLocation.search}${currentLocation.hash}`;
    const safeReturnUrl = getSafeCheckoutResumeReturnUrl(currentUrl);

    return safeReturnUrl === "/" ? "/login" : buildCheckoutResumeLoginUrl(safeReturnUrl);
};

export const isCheckoutOrderLoginRequiredError = (error: unknown): boolean => {
    const code = getCheckoutResumeErrorCode(error);
    return code === CHECKOUT_ORDER_LOGIN_REQUIRED || code === CHECKOUT_RESUME_LOGIN_REQUIRED;
};

export const isCheckoutOrderOwnerMismatchError = (error: unknown): boolean => {
    const code = getCheckoutResumeErrorCode(error);
    return code === CHECKOUT_ORDER_OWNER_MISMATCH || code === CHECKOUT_RESUME_OWNER_MISMATCH;
};
